/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsCompanyBranchCreateInput } from "../../entities/models/CompanyBranchCreateInput";
import { z } from "zod/v4";

export const modelsCompanyBranchCreateInputSchema = z.object({
    "address": z.optional(z.string()),
"name": z.string(),
"phone": z.optional(z.string()),
"timezone": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsCompanyBranchCreateInput>